import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  container: {
    animationDelay: '0.3s',
    animationFillMode: 'backwards',
    position: 'relative',
    transition: 'margin 0.4s ease',
  },
  error: {
    position: 'absolute',
    top: '100%',
    left: 0,
    color: 'rgb(244, 67, 54)',
  },
  edit: {
    marginTop: theme.spacing(-3),
    marginBottom: theme.spacing(-2),
    marginRight: theme.spacing(1),
  },
  field: {
    marginBottom: `${theme.spacing(-1)} !important`,
    marginTop: `${theme.spacing(-1)} !important`,
  },
  name: {
    display: 'inline-block',
  },
}))
